import { initializeFaro } from '@grafana/faro-web-sdk';

export const faro = initializeFaro({
  url: '/faro-collect',
  paused: !window.configuration.PUBLIC_FARO_ENABLED,
  app: {
    name: 'frontend',
  },
});
